import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContactType } from 'core/constants';
import { RootState } from 'core/store';

interface ContactTypesState {
  items: ContactType[];
  loaded: boolean;
}

export const initialState: ContactTypesState = {
  items: [],
  loaded: false
};

export const contactTypesSlice = createSlice({
  name: 'contactTypes',
  initialState,
  reducers: {
    fetchContactTypesSuccess: (state, action: PayloadAction<ContactType[]>) => {
      state.items = action.payload;
      state.loaded = true;
    },
    resetContactTypes: () => initialState
  }
});

export const { fetchContactTypesSuccess, resetContactTypes } =
  contactTypesSlice.actions;

export default contactTypesSlice.reducer;

export const selectContactTypeList =
  () =>
  (state: RootState): ContactType[] =>
    state.contactTypes.items;

export const selectContactTypesLoaded =
  () =>
  (state: RootState): boolean =>
    state.contactTypes.loaded;

export const selectContactTypeLabel =
  (type: string | undefined | null) =>
  (state: RootState): string => {
    const label = state.contactTypes.items.find(
      (contactType) => contactType.type === type
    )?.name;
    return label || type || '';
  };
